export default __webpack_public_path__ + "static/media/masterCardLogo.2e0b0a13.svg";